import React, { Component } from 'react';
import { NewClientModal } from '.';
import { ValidationModal } from '../components';
import DetailClientModal from './DetailClientModal';
import { CURRENCY, FORMAT_NUMBER, SYMBOL } from "../libs/utils/Const";

class ClientsModal extends Component {

    CloseModal = async () => {
        const { clearData, EnableClientsModal } = this.props;
        await clearData();
        await EnableClientsModal();
    }

    render() {

        const {
            partnerSearch,
            ChangePartnerSearch,
            businessPartners,
            SelectBusinessPartner,
            SearchPartners,
            SelectPartnerIndex,
            partnerIndex,
            businessPartner,
            clearData,
            RefreshBusinessPartner,
            showAlert,
            groupNumList,
            priceList,
            groupCodeList,
            CreateBusinessPartner,

            EditBusinessPartner,
            editMode,
            ChangeCardName,
            ChangeCellular,
            ChangeCreditLine,
            ChangeExtraDays,
            ChangeE_mail,
            UpdateBusinessPartner,
            updatebusinessPartner,
            DetailPartnerTools,
            ShowDetailClientModal,
            NextStepFunction,
            RefreshBusinessModel,
            newOrderModel,
            actionButton,
            CanChangePartner,
            ShowClientsModalReBilling,
            CFDI,
            RegimenFiscal,
            ChangeUSOCFDI,
            ChangeRegimenFiscal,
            Change_MetodoPago,
            Change_FormaPago,
            Change_Tipo_Relacion_CFDI,
            refreshModel,
            ContinueWithoutSave,
            states,
            countries,
            ChangeShowTemporalData,
            showTemporalData,
            ChanceTemporalDataToFalse,
            view,
            taxes,
            ChangeTaxes,
            pointer,
            RecoverDoc,
            ChangeOfUUIDRelation,
        } = this.props;

        return (
            <div>
                <div className="modal fade" id="clientsModal" data-backdrop="static" data-keyboard="false" tabIndex="-1" aria-labelledby="clientsModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-xl">
                        <div className="modal-content">
                            <div className="modal-header" style={{ background: "#343a40" }}>
                                <div className="container-fluid p-0">
                                <div className="row">
                                <div className="col-1 d-none d-md-block">
                                    {/* <button 
                                        className="btn btn-primary " 
                                        data-dismiss="modal" 
                                        data-target="#newClientModal" 
                                        data-toggle="modal" 
                                        style={{ backgroundColor: "#e9ecef", color: "#495057", border: "1px solid #ced4da", align: "right" }}
                                        onClick={GetDataPartner}>
                                        <i className="fa fa-plus" aria-hidden="true"></i>
                                    </button> */}
                                </div>
                                <div className="col-8 col-md-7">
                                    <div className="input-group">
                                        <div className="input-group-prepend" data-toggle="modal">
                                            <span className="input-group-text  btn-outline-secondary" id="basic-addon1" /*onClick={SearchPartners}*/ ><i className="fa fa-users" aria-hidden="true"></i></span>
                                        </div>
                                        <input
                                            type="text"
                                            className="form-control btn-outline"
                                            placeholder="Inserte el código o nombre del cliente"
                                            aria-label="Username"
                                            aria-describedby="basic-addon1"
                                            value={partnerSearch}
                                            onChange={(event) => ChangePartnerSearch(event.target.value)}
                                            onKeyPress={(event) => { event.key === 'Enter' && SearchPartners() }} />
                                    </div>
                                </div>
                                <div className="col-4 col-md-4">

                                    <button className="btn btn-primary " data-dismiss="modal" data-target="#vmRefreshClient" data-toggle="modal" style={{ backgroundColor: "#e9ecef", color: "#495057", border: "1px solid #ced4da", align: "right" }}>
                                        <i className="fa fa-refresh" aria-hidden="true"></i>
                                    </button>
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close" style={{ color: "white" }} onClick={this.CloseModal}>
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                            </div>
                                </div>

                            </div>
                            <div className="modal-body">
                                <div className="table-responsive scrollSearchs">
                                    <table className="table">
                                        <thead className='sticky-headerPOS'>
                                            <tr>
                                                <th scope="col" className="border-0 bg-light">
                                                    <div className="py-2 text-uppercase">Código</div>
                                                </th>
                                                <th scope="col" className="border-0 bg-light">
                                                    <div className="p-2 px-3 text-uppercase">Cliente</div>
                                                </th>
                                                <th scope="col" className="border-0 bg-light">
                                                    <div className="py-2 text-uppercase">Dirección</div>
                                                </th>
                                                <th scope="col" className="border-0 bg-light">
                                                    <div className="p-2 px-3 text-uppercase">Condiciones de pago</div>
                                                </th>
                                                <th scope="col" className="border-0 bg-light">
                                                    <div className="py-2 text-uppercase">Límite de crédito</div>
                                                </th>
                                                <th scope="col" className="border-0 bg-light">
                                                    <div className="py-2 text-uppercase"></div>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {!!businessPartners &&
                                                businessPartners.map((partner, index) => {
                                                    return (
                                                        <tr
                                                            key={`BusinessPartnerList${index}`}
                                                            style={{ background: index === partnerIndex && '#FFF8D2' }}
                                                            onClick={() => SelectPartnerIndex(index)}>
                                                            <th scope="row" className="border-0" >
                                                                <div className="p-2"> {partner.CardCode || ''}</div>
                                                            </th>
                                                            <td className="align-middle" >
                                                                <strong>
                                                                    <span
                                                                        data-dismiss="modal"
                                                                        onClick={() => ShowDetailClientModal(index)}
                                                                        style={{ textDecoration: "underline", cursor: 'pointer' }}>
                                                                        {partner.CardName || ''}
                                                                    </span>
                                                                </strong>
                                                            </td>
                                                            <td className="align-middle" >
                                                                <div>{partner.FullAddress || ''}</div>
                                                            </td>
                                                            <td className="align-middle" >
                                                                <div>{partner.PymntGroup || ''}</div>
                                                            </td>
                                                            <td className="align-middle" >
                                                                <div>{CURRENCY + ' ' + FORMAT_NUMBER.new(partner.CreditLine || '')}</div>
                                                            </td>
                                                            <td className="align-middle">
                                                                <span className="text-dark cursor-pointer"
                                                                    data-dismiss="modal"
                                                                    data-target="#vmChangeClient"
                                                                    data-toggle="modal">
                                                                    <i className="fa fa-plus-square-o" style={{ fontSize: "large" }}  ></i>
                                                                </span>
                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className="modal-footer">

                            </div>
                        </div>
                    </div>
                </div>

                <NewClientModal
                    businessPartner={businessPartner}
                    RefreshBusinessPartner={RefreshBusinessPartner}
                    showAlert={showAlert}
                    groupNumList={groupNumList}
                    CreateBusinessPartner={CreateBusinessPartner}
                    priceList={priceList}
                    groupCodeList={groupCodeList}
                    clearData={clearData} />

                {businessPartners.length > 0 &&
                    <DetailClientModal
                        businessPartners={businessPartners}
                        partnerIndex={partnerIndex}
                        EditBusinessPartner={EditBusinessPartner}
                        editMode={editMode}
                        showAlert={showAlert}
                        ChangeCardName={ChangeCardName}
                        ChangeCellular={ChangeCellular}
                        ChangeCreditLine={ChangeCreditLine}
                        ChangeExtraDays={ChangeExtraDays}
                        ChangeE_mail={ChangeE_mail}
                        UpdateBusinessPartner={UpdateBusinessPartner}
                        updatebusinessPartner={updatebusinessPartner}
                        DetailPartnerTools={DetailPartnerTools}
                        NextStepFunction={NextStepFunction}
                        ContinueWithoutSave={ContinueWithoutSave}
                        actionButton={!!actionButton ? actionButton : false}
                        RefreshBusinessModel={RefreshBusinessModel}
                        GroupNumList={groupNumList}
                        newOrderModel={newOrderModel}
                        CanChangePartner={!!CanChangePartner ? CanChangePartner : false}
                        ShowClientsModalReBilling={ShowClientsModalReBilling}
                        CFDI={CFDI}
                        RegimenFiscal={RegimenFiscal}
                        ChangeUSOCFDI={ChangeUSOCFDI}
                        ChangeRegimenFiscal={ChangeRegimenFiscal}
                        Change_MetodoPago={Change_MetodoPago}
                        Change_FormaPago={Change_FormaPago}
                        Change_Tipo_Relacion_CFDI={Change_Tipo_Relacion_CFDI}
                        ChangeTaxes={ChangeTaxes}
                        refreshModel={refreshModel}
                        states={states}
                        countries ={countries}
                        ChangeShowTemporalData={ChangeShowTemporalData}
                        showTemporalData={showTemporalData}
                        ChanceTemporalDataToFalse={ChanceTemporalDataToFalse}
                        view={view}
                        taxes={taxes}
                        pointer={pointer}
                        RecoverDoc={RecoverDoc}
                        ChangeOfUUIDRelation={ChangeOfUUIDRelation}
                    />
                }


                <ValidationModal
                    idValidation="vmRefreshClient"
                    message="¿Quiere usar un cliente genérico?"
                    idModalOrigin="#clientsModal"
                    idModalDestiny=""
                    eventOnclick={() => SelectBusinessPartner(partnerIndex, 'default')} />


                <ValidationModal
                    idValidation="vmChangeClient"
                    message="¿Quiere cambiar de cliente?"
                    idModalOrigin="#clientsModal"
                    idModalDestiny=""
                    eventOnclick={() => SelectBusinessPartner(partnerIndex)} />
            </div >
        );
    }
}

export default ClientsModal;